import { FieldProps } from 'formik';
import { get } from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import hideIcon from '../../../img/visibility-off.svg';
import showIcon from '../../../img/visibility-on.svg';
import { TextInput } from '../../presentational';

interface IOwnProps {
  id: string;
  name: string;
  onChange: (event: ChangeEvent<any>) => void;
}

type Props = IOwnProps & FieldProps<any>;

interface IOwnState {
  revealed: boolean;
  type: 'password' | 'text';
}

class PasswordField extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    revealed: false,
    type: 'password',
  };

  reveal = () => {
    this.setState({ 
      revealed: !this.state.revealed,
      type: !this.state.revealed ? 'text' : 'password',
    });
  }

  render() {
    const { field, form, ...props } = this.props;
    const { touched, errors } = form;

    return (
      <TextInput
        {...field}
        {...props}
        type={this.state.type}
        touched={get(touched, field.name)}
        errors={get(errors, field.name)}
        onChange={(event: ChangeEvent<any>) => {
          if (props.onChange) {
            props.onChange(event);
          }
          field.onChange(event);
        }}
        appendIcon={this.state.revealed ? showIcon : hideIcon }
        onAppendIconClick={this.reveal}
      />
    );
  }
}

export default PasswordField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/PasswordField/PasswordField.tsx